    jQuery(document).ready(function($){
        $('.ctm_slider').slick({
            dots: true,
            arrows: false,
            autoplay: true,
            autoplayspeed: 4000
          });
      });